import React, { useState, useEffect, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import Walleticon from './images/Walleticon.png';
import BuildCoin from './images/buildcoin.png';
import { useNavigate,useLocation  } from 'react-router-dom';


const Buildcoins = () => {
  // Example data, replace with your actual logic
  const buildcoins = 10000;
  const applicable = 200;
  const expiry = "31 Dec 2025";

    // const [applied, setApplied] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const customerId = location?.state?.customerId;
const orderId = location?.state?.orderId;
const cartTotal = location?.state?.cartTotal;
const categories = location?.state?.categories || [];
console.log('categories:', categories);
const brands = location?.state?.brands || [];
console.log('brands:', brands);
// const orderId = location?.state?.quotationId || location?.state?.quotationData?._id|| null;
const [isApplied, setIsApplied] = useState(false);
const appliedCoins = location?.state?.appliedCoins || 0;
console.log('appliedCoins:', appliedCoins);
console.log('cartTotal:', cartTotal);
console.log('order id:',orderId);
const fromCartPreview = location?.state?.fromCartPreview || false;
console.log('fromCartPreview:', fromCartPreview);
const [isProcessing, setIsProcessing] = useState(false);

const [walletBalance, setWalletBalance] = useState(0);
const [walletCoinsApplicable,setWalletCoinsApplicable] = useState(0)
console.log('walletCoinsApplicable:', walletCoinsApplicable);
const [walletCoinsApplied, setWalletCoinsApplied] = useState(false);
console.log('walletCoinsApplied:', walletCoinsApplied);
const [coinLedgers,setCoinLedgers] = useState([]);
//console.log("coin ledgers:",coinLedgers)
  const [appliedLedgerId, setAppliedLedgerId] = useState(null);
   // Only one applied at a time
const [applied, setApplied] = useState(() => {
  const fromCart = location?.state?.fromCartPreview;
  if (fromCart) return false;
  return localStorage.getItem('buildcoins_applied_ledger') !== null;
});


/*      useEffect(() => {
    // Check if applied in localStorage
    setApplied(localStorage.getItem('buildcoins_applied') === 'true');
    //getBuildcoinsWallet();
  }, []); */


useEffect(() => {
    if (cartTotal > 0) {
        getApplicableBuildcoins();
    }
}, [cartTotal]);

// Initialize component state properly on mount
useEffect(() => {
  // Reset processing state when component mounts to prevent stuck state
  setIsProcessing(false);
  
  // Clean up function on unmount
  return () => {
    setIsProcessing(false);
  };
}, []);

 useEffect(() => {
  const ledgerIdFromStorage = localStorage.getItem('buildcoins_applied_ledger');
  const amountFromStorage = localStorage.getItem('buildcoins_applied_amount');
  
  // Only consider it "applied" if both values exist
  if (ledgerIdFromStorage && amountFromStorage && amountFromStorage !== '0') {
    setAppliedLedgerId(ledgerIdFromStorage);
  } else {
    setAppliedLedgerId(null);
  }
}, []);


// Apply coins for a specific ledger
const handleApplyLedger = useCallback(async (ledger) => {
  console.log('🟡 Apply button clicked for ledger:', ledger.ledger_id);

  // Prevent double clicks
  if (isProcessing) {
    console.log('⚠️ Already processing, ignoring click');
    return;
  }

  setIsProcessing(true); // ✅ flag set
  console.log('🟢 isProcessing set to true');

  try {
    const res = await applyBuildCoinsFromWallet(ledger.ledger_id);
    const discount = res?.applied_buildcoins || ledger.usable_coins;
    console.log('✅ Buildcoins applied from API:', discount);

    localStorage.setItem('buildcoins_applied_ledger', ledger.ledger_id);
    localStorage.setItem('buildcoins_applied_amount', discount.toString());

    if (orderId) {
      console.log('📦 Updating quotation with orderId:', orderId);
      await updateQuotation(orderId, discount, cartTotal);
    }

    console.log('✅ Navigating back with buildcoins applied');
    // Reset before navigation to prevent stuck state
    setIsProcessing(false);  
    console.log('🔁 isProcessing reset to false');
    
    // Small delay before navigation to ensure state is updated
    setTimeout(() => {
      navigate(-1);
    }, 100);
  } catch (err) {
    console.error('❌ Failed to apply buildcoins:', err);
    alert('Failed to apply buildcoins');
    setIsProcessing(false); // Reset on error
  }
}, [isProcessing, orderId, cartTotal, navigate]);



  // Remove coins for a specific ledger
 const handleRemoveLedger = async (ledger) => {
  try {
    const customer = JSON.parse(localStorage.getItem('userData'));
    await removeAppliedBuildCoinsForOrderWalletCoins(customer._id, ledger.ledger_id);
    setAppliedLedgerId(null);
    setIsApplied(false); // <-- set not applied state
    localStorage.removeItem('buildcoins_applied_amount');


    // Navigate to CartPreview with reset state
    navigate(-1, {
      state: {
        appliedCoins: 0,
        ledgerId: null,
      },
    });
  } catch (err) {
    alert('Failed to remove buildcoins');
  }
};



  
  

const getBuildcoinsWallet = async () => {
  const token = sessionStorage.getItem('token');
  const customer = JSON.parse(localStorage.getItem('userData'));
  console.log(customer)
  const customerId = customer._id
  console.log(customerId)
  try {
    const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/get-buildcoins-wallet?customer_id=${customerId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token
      }
    });
           
    const data = await response.json();
    //await getApplicableBuildcoins()
    console.log(data)
    setWalletBalance(data?.wallet?.available_coins)
    //setWalletCoinsApplicable(data?.availableCoinLedgers[0]?.build_coins)
    //setCoinLedger(data?.availableCoinLedgers[0]);
  } catch (err) {
    console.error('Error getting buildcoins wallet:', err);
  }
}; 

const getApplicableBuildcoins = async () => {
  const token = sessionStorage.getItem('token');
  const customer = JSON.parse(localStorage.getItem('userData'));
  console.log(customer)
  const customerId = customer._id
  console.log(customerId)
  const consumer_id =  sessionStorage.getItem('consumer_id') || customerId;
  const category = categories || 'Tile Allied Products';
  const brand = brands || 'roff';
  const partner_id = '6889abb0dc50d682fe38fae2';
  const is_ecommerce = true;
  try {
    const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}rewards/get-applicable-buildcoins-from-wallet?consumer_id=${consumer_id}&category=${category}&brand=${brand}&is_ecommerce=${is_ecommerce}&amount=${cartTotal}&partner_id=${partner_id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token
      }
    });
           
    const data = await response.json();
    console.log("fetched applicable coins:",data)
    //setWalletCoinsApplicable(data?.applicable_coins)
    //setCoinLedger(data[0]);
    setCoinLedgers(data ? data.applicable_coins : []);
  } catch (err) {
    console.error('Error getting buildcoins wallet:', err);
  }
}; 


const applyBuildCoinsFromWallet = async (coinledgerId/* , orderId */) => {


 const  context = { 
    "order_amount": cartTotal
  }

  const request_body=JSON.stringify({
        coinledger_id: coinledgerId,
        order_id: orderId,
        context: context
      })

      console.log("apply coins request body:",request_body);

  try {
    const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}rewards/apply-buildcoins-from-wallet`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        // Add authorization header if needed
        // 'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: request_body
    });

    const data = await response.json();
    console.log("coins applied successfully:",data)

    if (!response.ok) {
      throw new Error(data.error || 'Failed to apply buildcoins');
    }

    return data;
  } catch (error) {
    console.error('Error applying buildcoins:', error);
    throw error;
  }
};



const updateQuotation = async (quotationId, discount, total ) => {
  const fullQuotation = location?.state?.fullQuotation;
  if (!fullQuotation) {
    console.warn('⚠️ Missing full quotation data in navigation state. Skipping quotation update.');
    return Promise.resolve(); // Return resolved promise to not break the flow
  }
 const discountedTotal = Math.max(total - discount, 0);
  const payload = {
    quotation_id: quotationId,
    customer_id: customerId,
    discount,
    total: discountedTotal,
    items: fullQuotation.product_categories?.flatMap(cat =>
      cat.items.map(item => ({
         item_id: item.item_id,
            item_image: item.item_image,
            item_name: item.item_name,
            quantity: item.quantity,
            initial_price: item.initial_price,
            selling_price: item.selling_price,
            cost_price: item.cost_price,
            tax_rate: item.tax_rate,
            total_tax_amount: item.total_tax_amount,
            total: item.total,
            UOM_id: item.UOM_id,
      }))
    ),
  };

  try {
    const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/save-quickbuy-quotation`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-token': sessionStorage.getItem('token'),
      },
      body: JSON.stringify(payload)
    });

    const data = await response.json();
    console.log('✅ Quotation updated:', data);
    return data;
  } catch (error) {
    console.error('❌ Failed to update quotation:', error);
  }
};


// Example usage in your frontend (React or plain JS)
async function removeAppliedBuildCoinsForOrderWalletCoins(consumer_id, coinledger_id) {
  try {
    const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}rewards/remove-applied-buildcoins-for-order-from-wallet`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        // Add authorization header if needed
        // 'x-token': sessionStorage.getItem('token')
      },
      body: JSON.stringify({ consumer_id, coinledger_id })
    });

    const data = await response.json();
    console.log("coins removed successfully:",data)
    if (!response.ok) throw new Error(data.error || data.message || 'Failed to remove buildcoins');
    return data;
  } catch (err) {
    console.error('Error removing applied buildcoins:', err);
    throw err;
  }
}

  return (
  <div className="min-h-screen bg-gray-100">
  {/* Header */}
  <div className="bg-white px-4 py-4 flex items-center border-b border-gray-200">
  <FontAwesomeIcon
          icon={faArrowLeft}
          className="w-5 h-5 text-gray-600 mr-4 cursor-pointer"
          onClick={() => navigate(-1)}
        />
            <h1 className="text-xl font-bold text-gray-800">Build Coins</h1>
  </div>

  {/* Input section with gray background */}
  <div className="bg-white px-4 py-6">
    <div className="flex justify-center">
      <div className="flex bg-gray-100 rounded-md px-2 py-2 w-full max-w-xl">
        <input
          type="text"
          placeholder="Have any buildcoins code? Type here"
          className="border-none bg-gray-100 px-3 py-2 text-sm focus:outline-none flex-1 rounded-l-md"
        />
        <button className="text-gray-300 text-sm mr-2">
          Apply
        </button>
      </div>
    </div>
  </div>

  

      {/* Wallet Buildcoins Section */}
{/* <div className="bg-white rounded-md shadow-sm p-4 mx-4 mt-6">
        <div className="mb-4">
          <h2 className="font-semibold text-lg">Wallet Buildcoins</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {coinLedgers && Array.isArray(coinLedgers) && coinLedgers.length > 0 && coinLedgers.some(ledger => ledger.usable_coins > 0) ? (
            coinLedgers
              .filter(ledger => ledger.usable_coins > 0)
              .map((ledger, idx) => {
                const isApplied = appliedLedgerId === ledger.ledger_id;
                return (
                  <div key={ledger.ledger_id || idx} className="bg-gray-50 rounded-md shadow p-4 flex flex-col justify-between">
                    <div className="flex items-center justify-between mb-2">
                      <div className="flex items-center">
                        <img src={Walleticon} alt="Wallet" className="h-7 w-7 object-contain mr-2" />

                     <span className="text-red-500 font-semibold block text-xs ml-9 mt-0">
                      Expires on {ledger.eligibility_details?.expiry?.[0]?.value
                        ? `${ledger.eligibility_details.expiry[0].value} days`
                        : 'N/A'}
                    </span>                      
                    </div>
                      {!isApplied ? (
                        <button
                          className="px-3 py-1 rounded-md font-semibold bg-red-500 text-white hover:bg-red-600"
                          onClick={() => handleApplyLedger(ledger)}
                          disabled={!!appliedLedgerId} 
                        >
                          Apply
                        </button>
                      ) : (
                        <div className="flex gap-2">
                          <button
                            className="px-3 py-1 rounded-md font-semibold bg-gray-200 text-gray-600 cursor-not-allowed"
                            disabled
                            aria-disabled="true"
                            title="Buildcoins applied to this order"
                          >
                            Applied
                          </button>
                          <button
                            className="px-3 py-1 rounded-md font-semibold border border-gray-300 text-gray-700 hover:bg-gray-50"
                            onClick={() => handleRemoveLedger(ledger)}
                          >
                            Remove
                          </button>
                        </div>
                      )}
                    </div>

                    <div className="mt-4 space-y-1">
                      <div className="flex items-center text-sm">
                        <span>
                          You currently have <span className="font-bold">{ledger.total_coins?.toLocaleString() || 0}</span> buildcoins.
                        </span>
                      </div>
                      <div className="flex items-center text-sm">
                        <span>
                          You can apply <span className="font-bold">{ledger.usable_coins?.toLocaleString() || 0}</span> buildcoins in this order.
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })
          ) : (
            <div className="text-gray-500">No buildcoins available.</div>
          )}
        </div>
      </div> */}
<div className="bg-white rounded-md shadow-sm p-3 mx-4 border border-gray-300">
  <div className="mb-1 mt-2 flex items-center ml-3">
    <img src={Walleticon} alt="Wallet" className="h-6 w-6 object-contain mr-2" />
    <h2 className="text-black font-bold text-lg">Wallet Buildcoins</h2>
  </div>

  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 ">
    {coinLedgers && Array.isArray(coinLedgers) && coinLedgers.length > 0 && coinLedgers.some(ledger => ledger.usable_coins > 0) ? (
      coinLedgers
        .filter(ledger => ledger.usable_coins > 0)
        .map((ledger, idx) => {
          const isApplied = appliedLedgerId === ledger.ledger_id;
          return (
            <div key={ledger.ledger_id || idx} className="rounded-md p-4 flex flex-col justify-between">
              {/* Header */}
            <div className="flex items-start justify-between mt-[-10px]">

                <span className="text-red-500 font-semibold text-xs">
                  Expires on {ledger.eligibility_details?.expiry?.[0]?.value
                    ? `${ledger.eligibility_details.expiry[0].value} days`
                    : 'N/A'}
                </span>

                {/* Button Section */}
 {appliedLedgerId === ledger.ledger_id ? (
  <div className="flex gap-1">
    <button
      className="px-2 py-0.5 rounded-md text-xs font-semibold bg-gray-200 text-gray-600 cursor-not-allowed"
      disabled
    >
      Applied
    </button>
    <button
      className="px-2 py-0.5 rounded-md text-xs font-semibold border border-gray-300 text-gray-700 hover:bg-gray-50"
      onClick={() => handleRemoveLedger(ledger)}
    >
      Remove
    </button>
  </div>
) : (
  <button
    className="px-2 py-1 rounded-md text-xs font-semibold bg-red-500 text-white hover:bg-red-600 disabled:opacity-50 disabled:cursor-not-allowed"
    onClick={() => handleApplyLedger(ledger)}
    disabled={!!appliedLedgerId || isProcessing}
  >
    {isProcessing ? 'Applying...' : 'Apply'}
  </button>
)}






              </div>

              {/* Description */}
              <div className={`mt-2 font-semibold text-sm ${isApplied ? 'text-green-600' : 'text-blue-600'}`}>
                {isApplied
                  ? `Applied ${ledger.usable_coins?.toLocaleString()} buildcoins on this order from your wallet.`
                  : `Apply ${ledger.usable_coins?.toLocaleString()} buildcoins on this order from your wallet.`}
              </div>

              {/* Tag */}
              <div className="mt-4">
                <div className="border border-gray-300 rounded-md px-3 py-1 text-center text-sm text-gray-500 w-fit">
                  WALLEBC
                </div>
              </div>
            </div>
          );
        })
    ) : (
      <div className="text-gray-500">No buildcoins available.</div>
    )}
  </div>
</div>








    </div>
  );
};

export default Buildcoins;